export default __webpack_public_path__ + "static/media/reactjs.2490e9fa.png";